import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import WhatsAppFloat from '@/components/WhatsAppFloat';
import { blogAPI } from '@/lib/api';
import { toast } from 'sonner';
import { ArrowLeft, Calendar } from 'lucide-react';

const BlogDetailPage = () => {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        setLoading(true);
        const response = await blogAPI.getBySlug(slug);
        setBlog(response.data);
      } catch (error) {
        console.error('Error fetching blog:', error);
        toast.error('Blog bulunamadı');
      } finally {
        setLoading(false);
      }
    };
    window.scrollTo(0, 0);
    fetchBlog();
  }, [slug]);


  if (loading) {
    return (
      <>
        <Navbar />
        <div className="min-h-screen flex items-center justify-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-4 border-navy border-t-transparent"></div>
        </div>
        <Footer />
      </>
    );
  }

  if (!blog) {
    return (
      <>
        <Navbar />
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-center">
            <h1 className="text-3xl font-bold text-navy mb-4">Blog bulunamadı</h1>
            <Link to="/blog" className="btn-primary">
              Bloga Dön
            </Link>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Helmet>
        <title>{blog.meta_title || blog.title} - Aden İklimlendirme</title>
        <meta name="description" content={blog.meta_description} />
      </Helmet>

      <Navbar />

      <article className="py-20 md:py-32" data-testid="blog-detail-page">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <Link to="/blog" data-testid="back-to-blog" className="inline-flex items-center text-orange mb-8 hover:underline">
            <ArrowLeft className="mr-2" size={20} />
            Bloga Dön
          </Link>

          <div className="mb-8">
            <img src={blog.cover_image} alt={blog.title} className="w-full rounded-lg shadow-lg" />
          </div>

          <div className="flex items-center text-sm text-slate-500 mb-6">
            <Calendar size={16} className="mr-2" />
            {new Date(blog.created_at).toLocaleDateString('tr-TR', {
              day: 'numeric',
              month: 'long',
              year: 'numeric',
            })}
          </div>

          <h1 className="text-4xl md:text-5xl font-bold text-navy mb-6">{blog.title}</h1>

          <div className="prose prose-lg max-w-none">
            <div dangerouslySetInnerHTML={{ __html: blog.content }} />
          </div>

          {blog.tags && blog.tags.length > 0 && (
            <div className="mt-12 pt-8 border-t">
              <p className="text-sm text-slate-500 mb-3">Etiketler:</p>
              <div className="flex flex-wrap gap-2">
                {blog.tags.map((tag, index) => (
                  <span key={index} className="bg-light text-navy px-3 py-1 rounded text-sm">
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          )}
        </div>
      </article>

      <Footer />
      <WhatsAppFloat />
    </>
  );
};

export default BlogDetailPage;
